import { useCallback, useEffect } from 'react'
import { useAccountId } from '@labrav/common'
import { useDispatch, useSelector } from '../../../store'
import {
  getActiveReceivedResaleAuthorizations,
  setSelectedActiveReceivedResaleAuthorizations,
} from '../../../modules/receivedResellerAuthorization/action'
import type { ReceivedResellerAuthorization } from '../../../modules/receivedResellerAuthorization/types'
import { SelectV2 } from '@labrav/react-components'
import { DataType } from '@labrav/react-components/lib/@types/types/forms'
import { isEmpty } from 'lodash'
import { SelectChangeEvent } from '@mui/material'
import { ALL_AUTHORIZATIONS_VALUE } from './constants'
import { getActiveReceivedResaleAuthList } from './helpers'
import type { AuthorizationSelectorProps } from './types'

export type { AuthorizationSelectorProps } from './types'

export const AuthorizationSelector = ({
  subscriptionId,
}: AuthorizationSelectorProps) => {
  const dispatch = useDispatch()
  const accountId = useAccountId({ product: 'flyout' })

  const selectedActiveReceivedResellerAuthorization = useSelector<string>(
    state =>
      state?.receivedResellerAuthorization
        ?.selectedActiveReceivedResellerAuthorization
  )

  const activeReceivedResellerAuthorizations = useSelector<
    ReceivedResellerAuthorization[]
  >(
    state =>
      state?.receivedResellerAuthorization?.activeReceivedResellerAuthorizations
  )

  useEffect(() => {
    if (isEmpty(activeReceivedResellerAuthorizations) && accountId) {
      dispatch(
        getActiveReceivedResaleAuthorizations({
          partnerId: accountId,
          subscriptionId,
        })
      )
    }
  }, [accountId, subscriptionId])

  const activeReceivedResaleAuthList = getActiveReceivedResaleAuthList(
    activeReceivedResellerAuthorizations || []
  )

  const handleAuthorizationChange = useCallback(
    async (event: SelectChangeEvent) => {
      const authorization = event.target.value as string
      const actualAuthorizationId =
        authorization === ALL_AUTHORIZATIONS_VALUE ? '' : authorization
      await dispatch(
        setSelectedActiveReceivedResaleAuthorizations(actualAuthorizationId)
      )
    },
    []
  )

  const defaultSelectedActiveReceivedResellerAuthorization =
    selectedActiveReceivedResellerAuthorization || ALL_AUTHORIZATIONS_VALUE

  return (
    <SelectV2
      field={{
        title: 'Authorization',
        placeHolder: 'Authorization',
        id: 'authorization-selector-dropdown',
        isRequired: false,
        humanReadableKey: 'authorization',
        isReadOnly: false,
        isCustom: false,
        defaultValue: defaultSelectedActiveReceivedResellerAuthorization,
        value: defaultSelectedActiveReceivedResellerAuthorization,
        dataType: 'enum' as DataType,
        options: activeReceivedResaleAuthList,
      }}
      onChange={handleAuthorizationChange}
      isError={false}
      size={'small'}
      minWidth="187px"
    />
  )
}
